import Cookies from 'js-cookie'
import { MD5 } from 'crypto-js'

import { CartResponse } from 'src/api/types'
import { RegItem, RegItemMinimal } from 'src/types/regItem'

let CART_QUANTITY_BY_REG_ITEM_CACHE_KEY: string
let CART_QUANTITY_BY_REG_ITEM = new Map()

export const getIsInCart = (
  regItem: RegItemMinimal | RegItem,
  cart?: CartResponse
) => {
  if (!cart) return false
  return getCartedQuantity(regItem, cart) > 0
}

export const getCartedQuantity = (
  regItem: RegItemMinimal | RegItem,
  cart?: CartResponse
) => {
  if (!cart) return 0

  const cartQuantityByRegItem = getCartQuantityByRegItem(cart)
  return cartQuantityByRegItem.get(regItem.id) || 0
}

export const getHandleDecreaseQuantity = (regItem: RegItemMinimal) => () => {
  console.log('Decrease quantity', regItem)
}

export const getHandleIncreaseQuantity = (regItem: RegItemMinimal) => () => {
  console.log('Increase quantity', regItem)
}

export const getHandleRemoveFromCart = (regItem: RegItemMinimal) => () => {
  console.log('Remove From Cart', regItem)
}

export const generateCartQuantityByRegItem = (cart: CartResponse) => {
  const newCartQuantityByRegItem = new Map()

  cart.reservations?.forEach((reservation) => {
    if (Cookies.get('email') !== reservation.email) return

    setOrIncrementMapValue(
      newCartQuantityByRegItem,
      reservation.regItemId,
      reservation.quantity
    )
  })

  cart.cart?.items?.forEach((cartItem) => {
    if (!cartItem.regItem) return

    setOrIncrementMapValue(
      newCartQuantityByRegItem,
      cartItem.regItem?.id,
      cartItem.quantity
    )
  })

  return newCartQuantityByRegItem
}

const getCartQuantityByRegItem = (cart: CartResponse) => {
  const cacheKey = generateCacheKey(cart)

  if (CART_QUANTITY_BY_REG_ITEM_CACHE_KEY !== cacheKey) {
    CART_QUANTITY_BY_REG_ITEM = generateCartQuantityByRegItem(cart)
    CART_QUANTITY_BY_REG_ITEM_CACHE_KEY = cacheKey
  }

  return CART_QUANTITY_BY_REG_ITEM
}

const generateCacheKey = (cart: CartResponse) =>
  MD5(JSON.stringify(cart)).toString()

const setOrIncrementMapValue = (
  map: Map<number, number>,
  key: number,
  value: number
) => {
  const existingValue = map.get(key)

  if (existingValue) {
    map.set(key, existingValue + value)
  } else {
    map.set(key, value)
  }
}
